module.exports = __webpack_public_path__ + "img/img-zhilian-s12-tuya.a361019d.png";